export const svg__search = (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M11.5 3C6.80558 3 3 6.80558 3 11.5C3 16.1944 6.80558 20 11.5 20C13.4845 20 15.3102 19.3199 16.7567 18.18L17.1601 18.5742L20.2929 21.7071L20.3871 21.7903C20.7794 22.0953 21.3466 22.0676 21.7071 21.7071C22.0976 21.3166 22.0976 20.6834 21.7071 20.2929L18.5661 17.1518L18.1721 16.7668C19.3167 15.3187 20 13.4892 20 11.5C20 6.80558 16.1944 3 11.5 3ZM11.5 5C15.0899 5 18 7.91015 18 11.5C18 15.0899 15.0899 18 11.5 18C7.91015 18 5 15.0899 5 11.5C5 7.91015 7.91015 5 11.5 5Z'
      fill='#0A1629'
    />
  </svg>
)

export const svg__plus = (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M12.9933 5.88338C12.9355 5.38604 12.5128 5 12 5C11.4477 5 11 5.44772 11 6V11H6L5.88338 11.0067C5.38604 11.0645 5 11.4872 5 12C5 12.5523 5.44772 13 6 13H11V18L11.0067 18.1166C11.0645 18.614 11.4872 19 12 19C12.5523 19 13 18.5523 13 18V13H18L18.1166 12.9933C18.614 12.9355 19 12.5128 19 12C19 11.4477 18.5523 11 18 11H13V6L12.9933 5.88338Z'
      fill='white'
    />
  </svg>
)

export const svg__filter = (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M15.0867 2C16.2603 2 17.2117 2.95138 17.2117 4.12497C17.2117 4.50324 17.1107 4.87465 16.9192 5.20085L15.9808 6.7991C15.4044 7.78094 15.4334 9.00449 16.0558 9.95789L17.5199 12.2009C18.2615 13.3369 17.9417 14.859 16.8057 15.6005C16.4064 15.8612 15.9398 16 15.463 16H12.9999V20.6C12.9999 21.1523 12.5522 21.6 11.9999 21.6C11.4871 21.6 11.0644 21.214 11.0067 20.7166L10.9999 20.6V16H8.55285C7.20012 16 6.10352 14.9034 6.10352 13.5507C6.10352 13.0707 6.24452 12.6013 6.50902 12.2009L8.02904 9.89929C8.63808 8.97711 8.69079 7.79476 8.16623 6.82205L7.29196 5.20085C6.72296 4.14572 7.11704 2.8291 8.17217 2.2601C8.48874 2.08938 8.84277 2 9.20244 2H15.0867ZM11.9999 14H15.463C15.5516 14 15.6383 13.9742 15.7125 13.9258C15.8972 13.8052 15.9657 13.5736 15.8877 13.3762L15.8452 13.2941L14.381 11.0511C13.3888 9.53122 13.3014 7.59936 14.1365 6.00214L14.2561 5.78648L15.1945 4.18824C15.2058 4.16905 15.2117 4.14721 15.2117 4.12497C15.2117 4.06975 15.1759 4.0229 15.1262 4.00637L15.0867 4H9.20244C9.17418 4 9.14635 4.00702 9.12148 4.02044C9.05514 4.05621 9.02205 4.12959 9.03437 4.19996L9.0523 4.25154L9.92657 5.87274C10.7611 7.42024 10.719 9.28608 9.8306 10.7893L9.69793 11.0015L8.17791 13.303C8.12938 13.3765 8.10352 13.4626 8.10352 13.5507C8.10352 13.7713 8.26247 13.9547 8.47208 13.9928L8.55285 14H11.9999Z'
      fill='#0A1629'
    />
  </svg>
)

export const svg__dot = (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M14 5C14 6.10457 13.1046 7 12 7C10.8954 7 10 6.10457 10 5C10 3.89543 10.8954 3 12 3C13.1046 3 14 3.89543 14 5ZM14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12ZM12 21C13.1046 21 14 20.1046 14 19C14 17.8954 13.1046 17 12 17C10.8954 17 10 17.8954 10 19C10 20.1046 10.8954 21 12 21Z'
      fill='#0A1629'
    />
  </svg>
)

export const svg__icon__chat = (
  <svg
    width='40'
    height='40'
    viewBox='0 0 40 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M39.9904 20.0245C39.9904 31.0544 31.0482 39.9973 20.0177 39.9973C8.98718 39.9969 0.0452888 31.055 0.0449219 20.0245C0.0449219 8.99461 8.98711 0.0517578 20.0177 0.0517578C31.0483 0.0517578 39.9904 8.99387 39.9904 20.0245Z'
      fill='#28D196'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M23.6201 9.68847C23.6201 9.23013 23.2486 8.85857 22.7902 8.85857L17.5424 8.85791C17.2301 8.85791 16.977 9.11107 16.977 9.42336V11.3503C16.977 11.5704 17.0644 11.7815 17.22 11.9371C17.3757 12.0927 17.5868 12.1802 17.8069 12.1802H22.7902C23.0105 12.1802 23.2217 12.0926 23.3773 11.9369C23.533 11.7811 23.6203 11.5698 23.6201 11.3496V9.68847ZM18.0846 14.3955C16.2498 14.3955 14.7623 12.908 14.7623 11.0732L13.6554 11.0752C12.4326 11.0752 11.4414 12.0664 11.4414 13.2891V28.7861C11.4412 29.3734 11.6744 29.9367 12.0896 30.3521C12.5048 30.7674 13.0681 31.0008 13.6554 31.0008H26.9404C28.1635 31.0008 29.155 30.0093 29.155 28.7861V13.2891C29.1556 12.7018 28.9227 12.1384 28.5078 11.7228C28.0928 11.3072 27.5297 11.0735 26.9424 11.0732H25.8354C25.8354 12.908 24.348 14.3955 22.5132 14.3955H18.0846Z'
      fill='#F9FAFC'
    />
    <g>
      <path
        d='M39.9911 20.0247C39.9911 31.0546 31.0489 39.9974 20.0184 39.9974C14.7289 40.0042 9.65415 37.9059 5.91406 34.1655L34.1234 5.88379C37.8856 9.62709 39.9979 14.7174 39.9911 20.0247Z'
        fill='#7B187D'
      />
    </g>
  </svg>
)

export const avart2 = {
  avartar1:
    'https://ava-grp-talk.zadn.vn/7/9/2/4/2/360/01b2dc10f09cbe843f65588d0e17b307.jpg',
}

export const icon = {
  icon1: (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1ZM12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3ZM16.6 13.2C16.1582 12.8686 15.5314 12.9582 15.2 13.4L15.0712 13.5544C14.9132 13.7291 14.6688 13.9589 14.3493 14.1913C13.6494 14.7003 12.8627 15 12 15C11.1373 15 10.3506 14.7003 9.65067 14.1913C9.22472 13.8815 8.93212 13.5762 8.8 13.4C8.46863 12.9582 7.84183 12.8686 7.4 13.2C6.95817 13.5314 6.86863 14.1582 7.2 14.6C7.44288 14.9238 7.86903 15.3685 8.47433 15.8087C9.49311 16.5497 10.6752 17 12 17C13.3248 17 14.5069 16.5497 15.5257 15.8087C16.131 15.3685 16.5571 14.9238 16.8 14.6C17.1314 14.1582 17.0418 13.5314 16.6 13.2ZM9.01 8C9.56228 8 10.01 8.44772 10.01 9C10.01 9.51284 9.62396 9.93551 9.12662 9.99327L9 10C8.44772 10 8 9.55229 8 9C8 8.48716 8.38604 8.06449 8.88338 8.00673L9.01 8ZM16.01 9C16.01 8.44772 15.5623 8 15.01 8L14.8834 8.00673C14.386 8.06449 14 8.48716 14 9C14 9.55229 14.4477 10 15 10L15.1266 9.99327C15.624 9.93551 16.01 9.51284 16.01 9Z'
        fill='#FDC748'
      />
    </svg>
  ),

  icon2: (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M20.334 13.2726C20.0581 13.7783 19.6425 14.1939 19.1368 14.4698L8.43735 20.3059C6.98281 21.0992 5.1605 20.5633 4.36711 19.1087C3.9799 18.3988 3.89566 17.5627 4.13348 16.7899L5.65781 11.8361L4.13348 6.88232C3.64619 5.29874 4.53491 3.61997 6.11849 3.13268C6.89134 2.89487 7.72747 2.97911 8.43735 3.36632L19.1368 9.2024C20.5914 9.99579 21.1274 11.8181 20.334 13.2726ZM18.5782 12.3149C18.8238 11.8647 18.6872 11.3088 18.2783 11.0199L18.1791 10.9582L7.47965 5.12211C7.24302 4.99304 6.96431 4.96496 6.70669 5.04423C6.21654 5.19506 5.9261 5.68833 6.01715 6.18067L6.04502 6.29411L7.49405 11.0031H12.75C13.3023 11.0031 13.75 11.4508 13.75 12.0031C13.75 12.516 13.364 12.9386 12.8666 12.9964L12.75 13.0031H7.39125L6.04502 17.3781C5.96575 17.6357 5.99383 17.9144 6.1229 18.151C6.36847 18.6012 6.90977 18.7874 7.37405 18.6L7.47965 18.5501L18.1791 12.714C18.3477 12.622 18.4862 12.4835 18.5782 12.3149Z'
        fill='white'
      />
    </svg>
  ),
  icon3: (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M12.2412 1.46512C14.1947 -0.488373 17.362 -0.488373 19.3154 1.46512C21.2097 3.35941 21.2671 6.395 19.4873 8.35882L19.3151 8.53972L10.1154 17.7293C8.94344 18.9013 7.04324 18.9013 5.87123 17.7293C4.7461 16.6042 4.7011 14.808 5.73658 13.6288L5.87165 13.4847L14.3616 5.0047C14.7524 4.61441 15.3856 4.61478 15.7759 5.00553C16.1361 5.36623 16.1635 5.93348 15.8583 6.32559L15.775 6.41975L7.28544 14.8993C6.89448 15.2903 6.89448 15.9242 7.28544 16.3151C7.64633 16.676 8.21419 16.7038 8.60722 16.3981L8.70161 16.3147L17.9012 7.12512C19.0737 5.95268 19.0737 4.05177 17.9012 2.87933C16.7757 1.75379 14.9788 1.70877 13.7995 2.74427L13.6554 2.87933L4.46544 12.0693C2.51152 14.0233 2.51152 17.1912 4.46544 19.1451C6.36016 21.0398 9.39642 21.0972 11.3603 19.3174L11.5412 19.1451L20.7312 9.95512C21.1218 9.56459 21.7549 9.56459 22.1454 9.95512C22.5059 10.3156 22.5337 10.8828 22.2286 11.2751L22.1454 11.3693L12.9554 20.5593C10.2205 23.2943 5.7862 23.2943 3.05123 20.5593C0.378415 17.8865 0.31767 13.5908 2.86899 10.8442L3.05123 10.6551L12.2412 1.46512Z'
        fill='#6D5DD3'
      />
    </svg>
  ),
  icon4: (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M21.1282 2.75736C18.8138 0.442958 15.0715 0.410439 12.7173 2.68427L10.9869 4.4044L10.9035 4.49836C10.5973 4.88976 10.6234 5.45707 10.9828 5.8186C11.3722 6.21026 12.0054 6.21211 12.397 5.82273L14.117 4.11273L14.2816 3.96241C15.8471 2.61026 18.2242 2.68184 19.714 4.17157C21.2569 5.71451 21.2786 8.20933 19.7627 9.77885L16.7749 12.7665L16.6066 12.9253C15.8026 13.6417 14.7405 14.0058 13.6601 13.9284C12.5025 13.8455 11.4379 13.2639 10.7428 12.3346C10.4119 11.8923 9.78526 11.802 9.34301 12.1328C8.90076 12.4636 8.81042 13.0903 9.14122 13.5325C10.184 14.9266 11.7808 15.799 13.5172 15.9233C15.2536 16.0477 16.9585 15.4117 18.1892 14.1805L21.1891 11.1807L21.3648 10.991C23.4718 8.61803 23.3817 5.01086 21.1282 2.75736ZM14.7428 10.3346C13.7 8.94055 12.1032 8.06814 10.3668 7.94378L10.0929 7.93044C8.4522 7.88801 6.86074 8.52017 5.69475 9.68658L2.69488 12.6865L2.51922 12.8761C0.412158 15.2491 0.502291 18.8563 2.75579 21.1098C5.07019 23.4242 8.81243 23.4567 11.1667 21.1828L12.8891 19.4607L12.9723 19.3665C13.2773 18.9742 13.2496 18.4069 12.8891 18.0465C12.4986 17.6559 11.8654 17.6559 11.4749 18.0465L9.76488 19.7565L9.60053 19.9066C8.03683 21.2569 5.65973 21.1853 4.17 19.6955C2.62707 18.1526 2.60539 15.6578 4.12128 14.0883L7.10909 11.1007L7.27735 10.9418C8.08136 10.2255 9.14346 9.86129 10.2239 9.93867C11.3815 10.0216 12.4461 10.6032 13.1412 11.5325C13.472 11.9748 14.0987 12.0651 14.541 11.7343C14.9832 11.4035 15.0736 10.7768 14.7428 10.3346Z'
        fill='#15C0E6'
      />
    </svg>
  ),
  icon5: (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M14.4361 2.30094C9.99001 1.18385 5.35367 3.23279 3.18649 7.27252C1.01931 11.3122 1.87631 16.3082 5.26591 19.3947C8.65552 22.4812 13.7097 22.8679 17.5293 20.3329C17.9895 20.0275 18.1149 19.4069 17.8095 18.9467C17.5042 18.4865 16.8835 18.3611 16.4234 18.6665C13.3676 20.6945 9.3242 20.3852 6.61247 17.9159C3.90073 15.4467 3.21512 11.4498 4.9489 8.21799C6.68267 4.98615 10.3918 3.34696 13.9488 4.24065C17.5058 5.13434 19.9996 8.33204 20 11.9996C20 13.8247 19.4251 14.7495 18.375 14.7495C17.3249 14.7495 16.75 13.8247 16.75 11.9995V8.24948L16.7432 8.13286C16.6855 7.63552 16.2628 7.24948 15.75 7.24948C15.2378 7.24948 14.8155 7.63456 14.7569 8.13099C13.9796 7.57601 13.0279 7.24948 12 7.24948C9.3766 7.24948 7.24995 9.37613 7.24995 11.9995C7.24995 14.6228 9.3766 16.7495 12 16.7495C13.3913 16.7495 14.6429 16.1513 15.5116 15.1981C16.113 16.1721 17.0691 16.7495 18.375 16.7495C20.7811 16.7495 22 14.7889 22 11.9995C21.9996 7.41507 18.8823 3.41803 14.4361 2.30094ZM14.75 11.9995C14.75 10.4807 13.5187 9.24948 12 9.24948C10.4812 9.24948 9.24995 10.4807 9.24995 11.9995C9.24995 13.5183 10.4812 14.7495 12 14.7495C13.5187 14.7495 14.75 13.5183 14.75 11.9995Z'
        fill='#3F8CFF'
      />
    </svg>
  ),
}
